var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.getStatusUmidadeClass(_vm.statusUmidade)},[_vm._v(" "+_vm._s(_vm.getStatusUmidadeNome(_vm.statusUmidade))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }